import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';

import Navigation from './components/Navigation';
import MobileNavigation from './components/MobileNavigation';
import FeaturedWork from './components/FeaturedWork';

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0
    };
  }

  updateScrollPosition = () => {
    let scrollTop = window.scrollY;
    this.setState({scrollTop});
  }

  componentDidMount() {
    window.addEventListener('scroll', (e) => {
      this.updateScrollPosition();
    })

    window.addEventListener('resize', (e) => {
      this.forceUpdate();
    })
  }

  render() {
    let {scrollTop} = this.state;

    let headerOpacity = Math.min(1, scrollTop / 300);
    let headerBackgroundColor = `rgba(33,45,58,${headerOpacity})`;

    let homeBackgroundTranslateY = scrollTop / 3 + 'px';
    let homeBackgroundTransform = `translate3d(0,${homeBackgroundTranslateY},0)`

    let homeTitleOpacity = Math.max(0, Math.min(1, (300 - scrollTop) / 300));

    return (
      <div className="App">
        <header className="App-header" style={{backgroundColor: headerBackgroundColor}}>
          <h1>Janne Kallunki</h1>
          {window.innerWidth >= 800 && <Navigation />}
        </header>

        {window.innerWidth < 800 && <MobileNavigation />}

        <section className="App-home">
          <div className="App-home-background" style={{transform: homeBackgroundTransform}}></div>
          <h1 style={{opacity: homeTitleOpacity}}>
            I'm an enthusiastic
            <strong>designer &amp; <br/>developer</strong>
            of digital experiences.
          </h1>
        </section>

        <FeaturedWork />

        <section id="skills" className="skills-section">
          <h2 className="section-header">Skills</h2>
          <div className="skills-content">

            <div className="skills-column">
              <h3>Development Skills</h3>
              <ul>
                <li>Web Development</li>
                <li>Mobile Development</li>
                <li>Augmented Reality</li>
                <li>Rapid Prototyping</li>
              </ul>
              <h3>Design Skills</h3>
              <ul>
                <li>User Research &amp; Testing</li>
                <li>UX, UI &amp; Graphic Design</li>
                <li>Typography</li>
                <li>Photography &amp; Editing</li>
              </ul>
            </div>

            <div className="skills-column">
              <h3>Weapons of Choice</h3>
              <ul>
                <li>React.js &amp; React Native</li>
                <li>Node.js</li>
                <li>TypeScript</li>
                <li>PostgreSQL</li>
              </ul>

              <h3>Familiar tools</h3>
              <ul>
                <li>Git</li>
                <li>Adobe Creative Suite</li>
                <li>Sketch</li>
                <li>MacOS/Linux/Windows</li>
              </ul>
            </div>
          </div>
          <div className="other-skills">
            <strong>Also used:</strong>
            <span>Vue.js, Redux, Webpack, Express.js, Koa.js, Angular, Sass/Less/Stylus, Ruby, Python, CoffeeScript, Swift, XCode, ARKit, Unity, Java, Android Studio, Gradle, C#, Haskell, PHP, WordPress, Lua, MySQL, MSSQL, MongoDB, C, C++, MATLAB etc.</span>
          </div>
          <div className="other-skills">
            <strong>Currently learning:</strong>
            <span>Multi-user AR, More modern JS (e.g. Svelte), Testing tools, DevOps, Audio &amp; Video Production</span>
          </div>
        </section>

        <section id="about" className="section-emphasis">
          <h2 className="section-header">About</h2>
          <div className="about-content">
            <div className="about-portrait">
              <img src={require('./assets/images/portrait-2.jpg')} alt="" />
            </div>
            <div className="about-column">
              <p>
                Born and raised in Tampere, Finland, creativity and self-improvement have guided my career and
                freetime for as long as I can remember. I picked up programming
                and web design as hobbies when I was about 10 years old,
                made websites as a part-time freelancer before my military service and after that started
                working as a full-time web developer.
              </p>
              <p>
                I have a bachelor's degree in computer science from University of Tampere while aiming
                to achieve master's degree in software development during year 2019.
              </p>
              <p>
                Usually I spend my freetime by making music, taking pictures and lifting heavy stuff at the gym,
                but sometimes it's just too hard not to write one more line of code.
              </p>
            </div>
          </div>
        </section>

        <section id="contact" className="contact-section section-negative">
          <h2 className="section-header">Contact</h2>
          <div className="contact-content">
            <div className="contact-title">
              Drop me a line!
            </div>
            <div className="contact-details">
              <span>Janne Kallunki</span>
              <span>+358 40 777 9620</span>
              <a href="mailto:janne@kallunki.org">janne@kallunki.org</a>
            </div>
            <div className="contact-social">
              <SocialIcon color="#fc6151" url="https://www.linkedin.com/in/jkallunki/" />
              <SocialIcon color="#fc6151" url="https://facebook.com/deetaili" />
              <SocialIcon color="#fc6151" url="https://instagram.com/deetaili" />
              <SocialIcon color="#fc6151" url="https://twitter.com/kallunkj" />
              <SocialIcon color="#fc6151" url="https://soundcloud.com/janne-kallunki" />
              <SocialIcon color="#fc6151" url="https://500px.com/jannekallunki" network="fivehundredpix" />
              <SocialIcon color="#fc6151" url="https://github.com/jkallunki" />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js